"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileTable = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var next_router_provider_1 = require("@newfront-insurance/next-router-provider");
var fuse_js_1 = __importDefault(require("fuse.js"));
var router_1 = require("next/router");
var react_1 = __importStar(require("react"));
var file_1 = require("../../providers/file");
var email_details_modal_1 = require("../email-details-modal");
var file_details_sheet_1 = require("../file-details-sheet");
var file_table_header_1 = require("../file-table-header");
var loader_1 = require("../loader");
var columns_1 = require("./lib/columns");
function FileTable(_a) {
    var columns = _a.columns, documentTypes = _a.documentTypes, files = _a.files, fileStatus = _a.fileStatus, _b = _a.hideSearchFilter, hideSearchFilter = _b === void 0 ? false : _b, _c = _a.initialSort, initialSort = _c === void 0 ? 'createdAt' : _c, _d = _a.initialSortDirection, initialSortDirection = _d === void 0 ? 'descending' : _d, limit = _a.limit, loading = _a.loading, onViewDetailsSheetChange = _a.onViewDetailsSheetChange, _e = _a.stickyColumnWidth, stickyColumnWidth = _e === void 0 ? '400px' : _e, uploadRoute = _a.uploadRoute;
    var router = (0, router_1.useRouter)();
    var selectedFileUuid = (0, next_router_provider_1.useQuery)('fileUuid');
    var _f = (0, react_1.useState)(), selectedEmailPreview = _f[0], setSelectedEmailPreview = _f[1];
    var _g = (0, react_1.useState)(''), search = _g[0], setSearch = _g[1];
    // show the view details sheet by adding fileUuid to the current url
    var showFileDetailsSheet = function (fileUuid) {
        if (!fileUuid)
            return;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        router.push({
            pathname: router.pathname,
            query: __assign(__assign({}, router.query), { fileUuid: fileUuid }),
        });
    };
    // hide the view details sheet by removing fileUuid to the current url
    var hideFileDetailsSheet = function () {
        var newQuery = __assign({}, router.query);
        delete newQuery.fileUuid;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        router.push({
            pathname: router.pathname,
            query: __assign({}, newQuery),
        });
    };
    // fuzzy search
    var fuse = new fuse_js_1.default(files || [], {
        keys: ['fileName', 'summary'],
    });
    var filteredResults = (0, react_1.useMemo)(function () {
        if (search) {
            var results = fuse.search(search);
            return results.map(function (res) { return res.item; });
        }
        return files;
    }, [search, files]);
    return (react_1.default.createElement("div", { style: { width: '100%' } },
        !hideSearchFilter && (react_1.default.createElement(core_ui_1.Box, { borderTop: 1, borderRight: 1, borderLeft: 1, borderTopRadius: 3, backgroundColor: "white" },
            react_1.default.createElement(core_ui_1.Padding, { size: 12 },
                react_1.default.createElement(core_ui_1.Flexbox, { justifyContent: "space-between" },
                    react_1.default.createElement(core_ui_1.Stack, { gap: 8, width: "400px" },
                        react_1.default.createElement("div", { style: { width: 300 } },
                            react_1.default.createElement(core_ui_1.Input, { type: "search", placeholder: "Search...", value: search, onChange: setSearch, testId: "files-ui-search-input" }))))))),
        react_1.default.createElement("div", { style: { position: 'relative' } },
            react_1.default.createElement(file_table_header_1.FileTableHeader, { uploadRoute: uploadRoute, fileStatus: fileStatus, currentDocumentTypes: documentTypes }),
            react_1.default.createElement(core_ui_1.TablePaginator, { initialSort: initialSort, initialSortDirection: initialSortDirection, tableHeadBackgroundColor: "#fff", stickyColumn: true, stickyColumnWidth: stickyColumnWidth, data: filteredResults || [], columns: columns || (0, columns_1.Columns)(showFileDetailsSheet, setSelectedEmailPreview), loading: loading, limit: limit, border: 1 }),
            loading && react_1.default.createElement(loader_1.Loader, { label: "Loading files..." })),
        selectedFileUuid && (react_1.default.createElement(file_1.FileProvider, { fileUuid: selectedFileUuid },
            react_1.default.createElement(file_details_sheet_1.FileDetailsSheet, { onClose: hideFileDetailsSheet, onChange: function () { return onViewDetailsSheetChange; }, handlePreviewEmail: setSelectedEmailPreview }))),
        selectedEmailPreview && (react_1.default.createElement(file_1.FileProvider, { fileUuid: selectedEmailPreview },
            react_1.default.createElement(email_details_modal_1.EmailDetailsModal, { isOpen: selectedEmailPreview, toggle: setSelectedEmailPreview })))));
}
exports.FileTable = FileTable;
